var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{attrs:{"id":"botaoSalvar","color":"primary","depressed":"","disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('salvar')}}},[_vm._v(" "+_vm._s(_vm.texto)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }